export default __webpack_public_path__ + "static/media/mnschedule_navicon-light.5c77b0d8.svg";